import styled from 'styled-components';

export const RowLine = styled.section`
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  align-items: baseline;
  p {
    margin-right: 1rem;
  }
  span {
    display: block;
  }
`;

export const LabelRow = styled.span`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #71717a;
  opacity: 0.8;
`;

export const SpanBlock = styled.span`
  font-family: 'Roboto';
  display: block;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #595959;
`;

export const ContainerNota = styled.div`
  background-color: #f2f2f2;
  border: 1px solid #e6e6e6;
  padding: 5px;
  margin-bottom: 5px;
`;
